var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiMobile1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2667 9.99934C17.4333 9.99934 18.3333 9.166 17.5333 6.43267C16.9917 4.591 15.4083 3.00767 13.5667 2.466C10.8333 1.666 10 2.566 10 4.73267V7.13267C10 9.166 10.8333 9.99934 12.5 9.99934H15.2667Z",
    stroke: "#2D995F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 12.2501C15.8917 16.1085 12.1917 18.9085 7.98336 18.2251C4.82502 17.7168 2.28336 15.1751 1.76669 12.0168C1.09169 7.82513 3.87502 4.12513 7.71669 3.3418",
    stroke: "#2D995F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiMobile1);
export default __webpack_public_path__ + "static/media/DI-mobile1.7f310cc0fabe44b9f056c05014fe293d.svg";
export { ForwardRef as ReactComponent };